import React, { useState, useRef } from "react";
import './Companies.scss';
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Faq from "react-faq-component";

export default function Companies({ BestWeightLoss, CitiesData }) {
    const [response, setResponse] = useState({});
    const [Disclosure, setDisclosure] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [NewArray, setNewArray] = useState([]);
    const [SellingFast, setSellingFast] = useState(false);

    const url = new URL(window.location.href);
    const location = useLocation()

    // Check if men or women
    useEffect(() => {
        if (url.searchParams.get('ca') === "Best-Weight-Loss--Meds-For-Woman" && BestWeightLoss) {
            const newArray = [
                BestWeightLoss.find(obj => obj.Gender === "Woman"),
                ...BestWeightLoss.filter(obj => obj.Gender !== "Woman")
            ].filter(Boolean);
            setNewArray(newArray);
        } else if (url.searchParams.get('ca') === "Best-Weight-Loss-Meds-For-Men" && BestWeightLoss) {
            const newArray = [
                BestWeightLoss.find(obj => obj.Gender === "Men"),
                ...BestWeightLoss.filter(obj => obj.Gender !== "Men")
            ].filter(Boolean);
            setNewArray(newArray);
        } else if (BestWeightLoss) {
            setNewArray(BestWeightLoss)
        }
    }, []);
    // Add scroll event listener only and AI Response
    useEffect(() => {
        (async () => {
            // try {
            //     const searchKeyword = ``
            //     const apiKey = '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'; // Replace with your actual API key
            //     const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'Authorization': `Bearer ${apiKey}`,
            //         },
            //         body: JSON.stringify({
            //             'model': 'gpt-3.5-turbo',
            //             'messages': [
            //                 {
            //                     'role': 'user',
            //                     'content': searchKeyword
            //                 }
            //             ]
            //         })
            //     })

            //     const dataChat = await resChat.json()

            //     setResponse(JSON.parse(dataChat.choices[0].message.content))
            // } catch (error) {
            //     console.log(error);
            // }
            // window.addEventListener('scroll', handleScroll, { passive: true });
            // return () => {
            //     window.removeEventListener('scroll', handleScroll);
            // };
        })()

    }, []);
    // Show popup after 3 seconds
    useEffect(() => {
        // Show popup after 7 seconds
        const timer = setTimeout(() => {
            setSellingFast(true);
        }, 7000);

        // Show popup after 14 seconds
        const timer2 = setTimeout(() => {
            setSellingFast(false);
        }, 16000);

        return () => {
            clearTimeout(timer);
            clearTimeout(timer2);
        };
    }, []);
    // Show popup when scrolling 400px from top
    useEffect(() => {




        const handleScroll = () => {
            if (window.scrollY > 600) {
                setShowPopup(true);
            } else {
                setShowPopup(false);
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const gclid = url.searchParams.get('gclid');
        console.log(gclid);
    }, []);


    return (
        <div className="Companies">
            {/* Helmet */}
            <Helmet>
                {/* TITLE */}
                <title>Emetya – Top 10 GLP-1 Weight Loss Medications Compared</title>

                {/* META TAGS */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="%PUBLIC_URL%/glp1-banner.jpg" />
                <meta property="og:url" content={`https://www.Emetya.com/top-10-glp-1-weight-loss-medications`} />
                <meta name="description" content="Compare the top 10 GLP-1 weight loss medications of 2025. Discover pricing, effectiveness, side effects, and how they rank based on real data and expert insights." />
                <meta property="og:title" content={`Emetya – $Top 10 GLP-1 Weight Loss Medications Compared`} />
                <meta property="og:description" content="Explore the most trusted GLP-1 medications like Ozempic, Wegovy, and Mounjaro. Find the best weight loss option for your goals with expert-backed comparisons." />
                <meta property="og:site_name" content="Emetya" />
                <meta name="keywords" content="GLP-1, weight loss medications, Ozempic, Wegovy, Mounjaro, top GLP-1 drugs, compare GLP-1, Emetya reviews, weight loss injections" />
            </Helmet>
            {/* CategoryNav */}
            <div className="CategoryDisclosure">
                <div className="CategoryNavShape">
                    <h1 onMouseOut={() => setDisclosure(false)}>We may earn a commission from featured offers, which can affect how and where they appear. <span onClick={() => setDisclosure(!Disclosure)}>Advertiser Disclosure.</span></h1>
                    {Disclosure ?
                        <div className="CategoryNavShapeDiscluser">
                            <h2>The content on this page was created independently from the Emetya editorial team. We may receive a commission from featured partners, which can influence how offers are presented — including their placement, rating, and order. In addition to compensation, we may also evaluate a brand’s reputation, popularity, and service quality when determining scores. While we strive to keep all information accurate and current, Emetya does not include every brand or offer available in the marketplace, and we cannot guarantee the completeness or accuracy of the content at the time of viewing.</h2>
                        </div>
                        : null}
                </div>
            </div>
            {/* CompaniesHeader */}
            <div className="CompaniesHeader">
                <img src={require(`../../Images/Logo.png`)} alt="" />
                <h1>Emetya<span>Health</span></h1>
            </div>
            {/* HomePageTopBanner */}
            <div className="HomePageTopBanner" >
                {url.searchParams.get('lp') == 'v2' && CitiesData ?
                    <>
                        <div className="HomePageTopBannerText" >
                            {url.searchParams.get('ca') ?
                                <h1>{url.searchParams.get('ca').replaceAll('-', ' ')} in {CitiesData.Full ? CitiesData.Full : CitiesData.City ? CitiesData.City : 'Your Area'} - {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}</h1>
                                :
                                <h1>Top Weight Loss Injections of {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}</h1>
                            }
                            {url.searchParams.get('kd') ?
                                <h2>Searching for <span>{url.searchParams.get('kd').charAt(0).toUpperCase() + url.searchParams.get('kd').slice(1)}</span> in {CitiesData.Full ? CitiesData.Full : CitiesData.City ? CitiesData.City : 'Your Area'} or Around You? Below are several of the most trusted telehealth platforms for getting GLP-1 weight loss prescriptions online. Choose the best fit for your goals and lifestyle.</h2>
                                :
                                <h2>Searching for effective GLP-1 treatments like Ozempic®, Wegovy®, Mounjaro®, Zepbound®, or compounded alternatives? We’ve reviewed the best telehealth providers offering prescription weight loss injections to help you choose the right plan for your goals.</h2>
                            }
                            <h3>
                                Last Update: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                            </h3>
                        </div>
                        <div className="HomePageTopBannerImgs">
                            <img className="HomePageTopBannerImg" src={require(`../../Images/BannerWeightLoss.png`)} alt="Chimney Cleaning" />
                            <img className="HomePageTopBannerImgTape" src={require(`../../Images/Tape.png`)} alt="Chimney Cleaning" />
                        </div>
                    </>
                    :
                    <>
                        <div className="HomePageTopBannerText" >
                            {url.searchParams.get('ca') ?
                                <h1>{url.searchParams.get('ca').replaceAll('-', ' ')} of {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}</h1>
                                :
                                <h1>Top Weight Loss Injections of {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}</h1>
                            }
                            {url.searchParams.get('kd') ?
                                <h2>Searching for <span>{url.searchParams.get('kd').charAt(0).toUpperCase() + url.searchParams.get('kd').slice(1)}</span>? Below are several of the most trusted telehealth platforms for getting GLP-1 weight loss prescriptions online. Choose the best fit for your goals and lifestyle.</h2>
                                :
                                <h2>Searching for effective GLP-1 treatments like Ozempic®, Wegovy®, Mounjaro®, Zepbound®, or compounded alternatives? We’ve reviewed the best telehealth providers offering prescription weight loss injections to help you choose the right plan for your goals.</h2>
                            }
                            <h3>
                                Last Update: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                            </h3>
                        </div>
                        <div className="HomePageTopBannerImgs">
                            <img className="HomePageTopBannerImg" src={require(`../../Images/BannerWeightLoss.png`)} alt="Chimney Cleaning" />
                            <img className="HomePageTopBannerImgTape" src={require(`../../Images/Tape.png`)} alt="Chimney Cleaning" />
                        </div>
                    </>

                }
            </div >
            {/* HomePageTopBannerShape */}
            <div className="HomePageTopBannerShape">
                <div className="HomePageTopBannerShapeWhite"></div>

            </div>
            {/* CompaniesTitle */}
            <div className="CompaniesTitle">

                <div className="CompanyPageRightHandyByVerifed">
                    <span>
                        <img src={require(`../../Images/verifed.png`)} />
                        <h1>Did you know?</h1>
                    </span>
                    <h2>Semaglutide cut weight by ~10.5% and improved liver health in up to 63% of patients (NEJM, 2024)</h2>
                </div>

            </div >
            {/* CompaniesList */}
            <div className="CompaniesList">
                {BestWeightLoss ? NewArray.filter(a => a.Active).map((A, index) => {
                    return (
                        <a className={`CompaniesListBox-WeightLoss ${A.Provider}`} href={A.AffiliateLink+(url.searchParams.get('gclid') ? '&sub2='+ url.searchParams.get('gclid') : '')} target="_blank" key={A.Provider + index}>
                            {index === 0 ?
                                <div className="CompaniesListBoxRating">
                                    <img src={require(`../../Images/ranking.png`)} alt="" />
                                    <h2>{A.Score.TitleDemand}</h2>
                                </div>
                                : index === 1 ?
                                    <div className="CompaniesListBoxRatingGreen">
                                        <img src={require(`../../Images/high-quality.png`)} alt="" />
                                        <h2>Highly Rated</h2>
                                    </div>
                                    : null
                            }
                            <div className="CompaniesListBoxTop">
                                <div className="CompaniesListBoxTopMain">
                                    <div className="CompaniesListBoxTopLeft">
                                        <img src={A.Logo} alt={A.Provider} />
                                    </div>
                                    <div className="CompaniesListBoxMiddle">
                                        <h1  >{A.Provider}</h1>
                                        {A.Attributes.map((attributeObj, attrIndex) => (
                                            <h3 key={attrIndex}><img src={require(`../../Images/check-mark.png`)} alt="" />{attributeObj.attribute}</h3>
                                        ))}

                                    </div>
                                </div>

                                <div className="CompaniesListBoxTopRight">
                                    <div className="CompaniesListBoxTopRightRating">
                                        <h1>{A.Score.RatingCount}</h1>
                                        <span>
                                            <h2>{A.Score.Rating}</h2>
                                            <span>
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                            </span>
                                        </span>
                                    </div>
                                    <h3>{A.Score.TitleSecDemand}</h3>
                                </div>
                            </div>
                            <div className="CompaniesListBoxBottom">
                                <img src={require(`../../Images/discount.png`)} alt="" />
                                <h2>{A.Promostion}</h2>
                                {/* <h2>{A.bottomLine.bottomLineText}</h2> */}
                            </div>
                            <div className="CompaniesListBoxBoook">
                                <span className="CompaniesListBoxBoookLeft">
                                    <h2>Get started with {A.Provider}</h2>
                                    <h3>Trusted by {A.Score.TimesVoted.toLocaleString()}+ users</h3>
                                </span>
                                <span className="CompaniesListBoxBoookRight">
                                    <button >Go to {A.Provider}</button>
                                    <button >Visit Site <img src={require(`../../Images/back.png`)} alt="" /></button>
                                </span>
                            </div>
                        </a>)
                }) : <h1>Loading...</h1>}
            </div >

            {/* Our Top Choice */}
            <div className="CompaniesList CompaniesList2">
                <h1 className="CompaniesList2Title">Our Top Choice</h1>
                {BestWeightLoss ? NewArray.filter(a => a.Active).slice(0, 1).map((A, index) => {
                    return (
                        <a
                            className={`CompaniesListBox-WeightLoss OurTopChoiceBox ${BestWeightLoss[0].Provider}`}
                            href={BestWeightLoss[0].AffiliateLink +(url.searchParams.get('gclid') ? '&sub2='+ url.searchParams.get('gclid') : '')}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <div className="CompaniesListBoxRating">
                                <img src={require(`../../Images/ranking.png`)} alt="" />
                                <h2>{BestWeightLoss[0].Score.TitleDemand}</h2>
                            </div>
                            <div className="CompaniesListBoxTop">
                                <div className="CompaniesListBoxTopMain">
                                    <div className="CompaniesListBoxTopLeft">
                                        <img src={BestWeightLoss[0].Logo} alt={BestWeightLoss[0].Provider} />
                                    </div>
                                    <div className="CompaniesListBoxMiddle">
                                        <h1>{BestWeightLoss[0].Provider}</h1>
                                        {BestWeightLoss[0].Attributes.map((attributeObj, attrIndex) => (
                                            <h3 key={attrIndex}>
                                                <img src={require(`../../Images/check-mark.png`)} alt="" />
                                                {attributeObj.attribute}
                                            </h3>
                                        ))}
                                    </div>
                                </div>
                                <div className="CompaniesListBoxTopRight">
                                    <div className="CompaniesListBoxTopRightRating">
                                        <h1>{BestWeightLoss[0].Score.RatingCount}</h1>
                                        <span>
                                            <h2>{BestWeightLoss[0].Score.Rating}</h2>
                                            <span>
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                            </span>
                                        </span>
                                    </div>
                                    <h3>{BestWeightLoss[0].Score.TitleSecDemand}</h3>
                                </div>
                            </div>
                            <div className="CompaniesListBoxBottom">
                                <img src={require(`../../Images/discount.png`)} alt="" />
                                <h2>{BestWeightLoss[0].Promostion}</h2>
                            </div>
                            <div className="CompaniesListBoxBoook">
                                <span className="CompaniesListBoxBoookLeft">
                                    <h2>Get started with {BestWeightLoss[0].Provider}</h2>
                                    <h3>Trusted by {BestWeightLoss[0].Score.TimesVoted.toLocaleString()}+ users</h3>
                                </span>
                                <span className="CompaniesListBoxBoookRight">
                                    <button>Go to {BestWeightLoss[0].Provider}</button>
                                    <button>Visit Site</button>
                                </span>
                            </div>
                        </a>)
                }) : <h1>Loading...</h1>}
            </div>
            {/* CompaniesText */}
            <div className="CompaniesText" >
                <h2>Are Weight Loss Medications Like Ozempic®, Wegovy®, and Saxenda® Effective?</h2>
                <p>GLP-1 medications such as <strong>Ozempic®</strong>, <strong>Wegovy®</strong>, <strong>Saxenda®</strong>, and <strong>Zepbound®</strong> have transformed how Americans approach weight loss. Backed by clinical research, these medications help regulate appetite, reduce cravings, and improve metabolic function — supporting consistent weight loss when paired with healthy lifestyle changes.</p>

                <p>According to board-certified obesity specialists, medications like these offer an “all-hands-on-deck” approach to weight management — especially for individuals who haven’t had success with diet and exercise alone. While not everyone is eligible, for many patients they represent a game-changing opportunity.</p>

                <h3>What Are GLP-1 Receptor Agonists?</h3>
                <p>GLP-1 medications mimic the glucagon-like peptide-1 hormone produced naturally in the gut. This hormone signals fullness to the brain, slows gastric emptying, and helps control blood sugar levels. These effects combine to reduce appetite and support long-term weight loss.</p>

                {/* ///////////////////////////////////////////////////////////////////////////////  */}

                <h2>Are Weight Loss Injections Right for You?</h2>
                <p>While today’s leading weight loss injections can deliver impressive results, they aren’t the right choice for everyone. These treatments are generally recommended for people who meet specific health and lifestyle criteria, as determined by qualified medical professionals.</p>
                <p>Not sure if they’re a fit for you? The providers we’ve reviewed offer convenient online consultations and short eligibility quizzes to help determine whether weight loss injections are suitable for your needs. Explore our top-rated options today and see if you qualify!</p>

                {/* ///////////////////////////////////////////////////////////////////////////////  */}
                <h2>Popular FDA-Approved Weight Loss Medications</h2>

                <h3>Ozempic® (semaglutide)</h3>
                <p><strong>Ozempic®</strong> is FDA-approved to treat type 2 diabetes but is often prescribed off-label for weight loss. It contains semaglutide, the same active ingredient as Wegovy®, and works by decreasing appetite, stabilizing blood sugar, and promoting satiety. Ozempic® is a once-weekly injection and is only available by prescription.</p>

                <h3>Wegovy® (semaglutide)</h3>
                <p><strong>Wegovy®</strong> is FDA-approved specifically for weight loss in individuals with a BMI of 30+ or 27+ with a weight-related condition. It’s a weekly injectable that delivers clinically significant weight loss. Studies show average reductions of 15% or more in total body weight over 12 months.</p>

                <h3>Saxenda® (liraglutide)</h3>
                <p><strong>Saxenda®</strong> is a daily GLP-1 injection approved for chronic weight management in adults and adolescents. It contains liraglutide, which helps control appetite and reduce calorie intake. Saxenda® has been trusted for years and is one of the earliest GLP-1 medications approved for weight loss.</p>

                <h3>Zepbound® (tirzepatide)</h3>
                <p><strong>Zepbound®</strong> is a newer GLP-1/GIP dual agonist that combines two mechanisms for even greater impact on weight loss and blood sugar. It’s FDA-approved for obesity and overweight patients with related conditions, and early results show it may outperform semaglutide-based alternatives.</p>
                <img src={require(`../../Images/Banner2.jpg`)} alt="" />

                {/* ///////////////////////////////////////////////////////////////////////////////  */}
                <h2>What Are Weight Loss Injections?</h2>
                <p>Weight loss injections are prescription treatments designed to support safe and effective weight management. Many of today’s most popular options are <strong>GLP-1 medications</strong>, which work by helping you feel full faster, curbing your appetite, and improving your body’s ability to burn calories. This combination can make it easier to lose weight and maintain your results over time.</p>
                <p>Some injectable weight loss medications take a different approach by targeting the digestive process. These treatments slow the rate at which your body absorbs food, leading to a more gradual rise in blood sugar levels. Maintaining stable blood sugar can help reduce cravings, prevent energy crashes, and further support long-term weight loss.</p>
            </div >
            {/* CompaniesList */}
            <div className="CompaniesList CompaniesList3">
                <h1 className="CompaniesList3Title">Our top picks {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}</h1>

                {BestWeightLoss ? NewArray.filter(a => a.Active).slice(0, 3).map((A, index) => {
                    return (
                        <a className={`CompaniesListBox-WeightLoss ${A.Provider}`} href={A.AffiliateLink+(url.searchParams.get('gclid') ? '&sub2='+ url.searchParams.get('gclid') : '')} target="_blank" key={A.Provider + index}>
                            {index === 0 ?
                                <div className="CompaniesListBoxRating">
                                    <img src={require(`../../Images/ranking.png`)} alt="" />
                                    <h2>{A.Score.TitleDemand}</h2>
                                </div>
                                : index === 1 ?
                                    <div className="CompaniesListBoxRatingGreen">
                                        <img src={require(`../../Images/high-quality.png`)} alt="" />
                                        <h2>Highly Rated</h2>
                                    </div>
                                    : null
                            }
                            <div className="CompaniesListBoxTop">
                                <div className="CompaniesListBoxTopMain">
                                    <div className="CompaniesListBoxTopLeft">
                                        <img src={A.Logo} alt={A.Provider} />
                                    </div>
                                    <div className="CompaniesListBoxMiddle">
                                        <h1  >{A.Provider}</h1>
                                        {A.Attributes.map((attributeObj, attrIndex) => (
                                            <h3 key={attrIndex}><img src={require(`../../Images/check-mark.png`)} alt="" />{attributeObj.attribute}</h3>
                                        ))}

                                    </div>
                                </div>

                                <div className="CompaniesListBoxTopRight">
                                    <div className="CompaniesListBoxTopRightRating">
                                        <h1>{A.Score.RatingCount}</h1>
                                        <span>
                                            <h2>{A.Score.Rating}</h2>
                                            <span>
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                            </span>
                                        </span>
                                    </div>
                                    <h3>{A.Score.TitleSecDemand}</h3>
                                </div>
                            </div>
                            <div className="CompaniesListBoxBoook">
                                <span className="CompaniesListBoxBoookLeft">
                                    <h2>Get started with {A.Provider}</h2>
                                    <h3>Trusted by {A.Score.TimesVoted.toLocaleString()}+ users</h3>
                                </span>
                                <span className="CompaniesListBoxBoookRight">
                                    <button >Go to {A.Provider}</button>
                                    <button >Visit Site</button>
                                </span>
                            </div>
                        </a>)
                }) : <h1>Loading...</h1>}
            </div >
            {/* CompaniesText */}
            <div className="CompaniesText" >

                <h2>Compounded GLP-1 Medications</h2>
                <p>Due to high demand and limited insurance coverage, some telehealth providers offer <strong>compounded versions of semaglutide or tirzepatide</strong>. These are custom-prepared by licensed U.S. compounding pharmacies and may be more affordable and accessible.</p>

                <p><strong>Important Disclaimer:</strong> Our partners may provide compounded medications that <strong>have not undergone independent review or FDA approval</strong> for safety or effectiveness. Always consult with your provider to determine whether compounded medications are appropriate for your situation.</p>

                {/* ///////////////////////////////////////////////////////////////////////////////  */}

                <h2>Weight Loss Medications vs. Fat Burners</h2>
                <p>Unlike over-the-counter fat burning supplements, GLP-1 medications are <strong>prescription-based, clinically validated, and physician-guided</strong>. They are designed to treat obesity as a medical condition — not just as a cosmetic concern. Fat burners may claim quick results, but they are often unregulated and lack long-term effectiveness.</p>

                {/* ///////////////////////////////////////////////////////////////////////////////  */}

                <h2>How to Choose the Best Weight Loss Program</h2>
                <p>Choosing a weight loss program isn’t just about picking the cheapest or fastest option — it’s about finding the right fit for your health goals and support needs. Look for providers that offer:</p>
                <ul>
                    <li>Licensed medical providers with GLP-1 prescribing experience</li>
                    <li>Transparent pricing with no hidden fees</li>
                    <li>Ongoing coaching or clinical support</li>
                    <li>Options for both injectables and oral GLP-1s</li>
                </ul>

                <p>Many patients stay on GLP-1 medications for several months or longer as they build sustainable habits around nutrition and exercise. These medications are most effective when combined with a balanced lifestyle — and that’s where great providers come in.</p>
                <img src={require(`../../Images/Banner3.jpg`)} alt="" />

                {/* ///////////////////////////////////////////////////////////////////////////////  */}

                <h2>Final Thoughts</h2>
                <p>GLP-1 weight loss medications aren’t miracle cures, but they are powerful tools that can support real, measurable change. Whether you’re considering Ozempic®, Wegovy®, Saxenda®, or a compounded alternative, working with a trusted provider is key.</p>

                <p>Explore our curated list of top GLP-1 programs to find the option that fits your goals. Whether you're just beginning your journey or looking for a smarter solution, your healthier future may be just a click away.</p>

            </div >
            {/* CompaniesFooter */}
            < div className="CompaniesFooter" >
                <h6>Information provided on Emetya is for educational purposes only and is not intended as medical advice. Your health and wellness needs are personal, and the products or services featured may not be suitable for your individual situation. Emetya does not provide medical diagnoses, treatment plans, or personalized health recommendations. Always consult a licensed healthcare provider for advice tailored to your specific medical needs.</h6>
                <div className="Footerlogo">
                    <img src={require(`../../Images/Logo.png`)} alt="" />
                    <h1>Emetya<span>Health</span></h1>
                </div>
                <h5>©2025 Emetya Health. All rights reserved.</h5>
                <span>
                    <a href="https://www.emetya.com/privacy-policy">Privacy Policy</a>
                    <a href="https://www.emetya.com/terms-of-use">Terms of Use</a>
                </span>
            </div >
            {/* CompaniesPopUp */}
            <div className="CompaniesPopUp_Medvi" style={{
                opacity: showPopup ? 1 : 0,
                transform: showPopup ? "translateY(0)" : "translateY(40px)",
                transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
            }}
            >
                {BestWeightLoss ? BestWeightLoss.slice(0, 1).map((A, index) => {
                    return (
                        <a className={`${A.Provider}`} href={A.AffiliateLink+(url.searchParams.get('gclid') ? '&sub2='+ url.searchParams.get('gclid') : '')} target="_blank" key={A.Provider + index}>
                            <div className="CompaniesPopUpMainText">
                                <span>
                                    <img src={A.Logo} alt={A.Provider} />
                                    <img src={require(`../../Images/RemedyMedsBottle.png`)} />
                                </span>
                                <h2>Emetya Special:<strong> {A.Promostion}</strong></h2>
                            </div>
                            <div className="CompaniesPopUpMainText2">

                                <button><img src={require(`../../Images/back.png`)} alt="" /></button>
                            </div>
                        </a>
                    )
                }) : <h1>Loading...</h1>}
            </div>
            {/* CompaniesPopUp */}
            {/* {SellingFast ? */}
            <div className="CompaniesPopUp_SellingFast" style={{
                opacity: SellingFast ? 1 : 0,
                transform: SellingFast ? "translateY(40)" : "translateY(0)",
                transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
            }}>
                <img className="closeMenuCompaniesPopUp_SellingFast" src={require(`../../Images/close.png`)} alt="" onClick={() => setSellingFast(false)} />
                <div className="CompaniesPopUpMainText">
                    <img src={require(`../../Images/coupon2.png`)} alt="" />
                    <h2>Selling Fast!</h2>
                </div>
                <p>
                    Weight loss injections are going fast! Don’t wait-start your weight loss journey today.
                    <strong>383 people bought today!</strong>
                </p>
            </div>
            {/* : null} */}

        </div >
    )
}

